/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { DescriptionsKeyValue } from './descriptionsKeyValue';
import { HealthLevel } from './healthLevel';


export interface Descriptions { 
    description: string;
    description_key_value?: Array<DescriptionsKeyValue>;
    level: HealthLevel;
}
export namespace Descriptions {
}


